import { PRO_LANGUAGE_CODES } from '@application/constants';
import { allLanguageSelectOptions, binarySelectOptions, useRouter } from '@application/utils';
import { EducatorTypeEnum, ProfessionalTypeEnum } from '@gql/graphql';
import {
  FiltersWithModalInputSelectField,
  FiltersWithModalInputWrapper,
} from '@presentation/components';
import { BREAKPOINTS } from '@presentation/styles';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import type { ProListPageData } from '../../types';

export const Filters: FC<Pick<ProListPageData, 'type'>> = (props) => {
  const { type } = props;
  const { language } = useRouter();

  const { translate } = useTranslation();

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.tablet}px)` });

  const educatorTypeOptions = useMemo(() => {
    return Object.keys(EducatorTypeEnum).map((educatorType) => ({
      value: educatorType as EducatorTypeEnum,
      label: translate(`enum.educatorType.${educatorType}`),
    }));
  }, [translate]);

  return (
    <>
      {type === ProfessionalTypeEnum.EDUCATOR ? (
        <FiltersWithModalInputWrapper>
          <FiltersWithModalInputSelectField<EducatorTypeEnum>
            placeholder={translate('common.inputs.educatorTypes.placeholder')}
            relativeDropdown={isMobile}
            name="educatorTypes"
            multiple
            options={educatorTypeOptions}
          />
        </FiltersWithModalInputWrapper>
      ) : (
        <FiltersWithModalInputWrapper>
          <FiltersWithModalInputSelectField<boolean>
            placeholder={translate('common.inputs.hasBooking.placeholder')}
            name="hasBooking"
            options={binarySelectOptions(translate)}
          />
        </FiltersWithModalInputWrapper>
      )}

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<number>
          placeholder={translate('common.inputs.maxDistance.placeholder')}
          relativeDropdown={isMobile}
          name="maxDistance"
          useSearch={false}
          sortBySelected={false}
          options={[
            { value: 5000, label: '5km' },
            { value: 10000, label: '10km' },
            { value: 20000, label: '20km' },
            { value: 30000, label: '30km' },
            { value: 50000, label: '50km' },
            { value: 100000, label: '100km' },
          ]}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<string>
          relativeDropdown={isMobile}
          placeholder={translate('common.inputs.spokenLanguages.placeholder')}
          name="spokenLanguages"
          multiple
          options={allLanguageSelectOptions(language, PRO_LANGUAGE_CODES)}
        />
      </FiltersWithModalInputWrapper>
    </>
  );
};
